import { Routes, Route, Navigate } from 'react-router-dom'
import { QueryParamProvider } from 'use-query-params'
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6'
import qs from 'query-string'

import EnvironmentBanner from '@/gf/components/EnvironmentBanner'
import ConfigProvider from '@/gf/providers/ConfigProvider'
import MsgsProvider from '@/gf/providers/MsgsProvider'
import ErrorTrackerProvider from '@/gf/providers/ErrorTracker'
import SessionProvider from './providers/SessionProvider'
import StableNavigateProvider from '@/gf/providers/StableNavigateProvider'
import LegacyGqlClientProvider from './providers/LegacyGqlClient'
import GqlClientProvider from './providers/GqlClient'
import ApolloWsClientProvider from './providers/ApolloWsClient'

import ErrorBoundary from '@/gf/components/ErrorBoundary'
import HashLinks from '@/gf/components/HashLinks'
import Home from './pages/Home'
import Products from './pages/Products'
import Shipping from './pages/Shipping'
import EditOrder from './pages/EditOrder'
import CreateOrder from './pages/CreateOrder'
import RequestForQuotes from './pages/RequestForQuotes'
import RequestForQuote from './pages/RequestForQuote'
import Orders from './pages/Orders'
import Order from './pages/Order'
import Customers from './pages/Customers'
import Accounts from './pages/Accounts'
import Account from './pages/Account'
import NotFound from './pages/NotFound'
import Product from './pages/Product'
import CreateProduct from './pages/CreateProduct'
import Customer from './pages/Customer'
import Settings from './pages/Settings'
import Transactions from './pages/Transactions'
import ConfigureShipment from './pages/ConfigureShipment'
import Metrics from './pages/Metrics'
import ProductDiagnostics from './pages/ProductDiagnostics'
import MachineDetails from './pages/MachineDetails'
import Reporting from './pages/Reporting'
import Inbox from './pages/Inbox'
import CreateRequestForQuote from './pages/createRequestForQuote/CreateRequestForQuote'
import DealerHubRedirect from './components/DealerHubRedirect'

const App = () => (
  <ConfigProvider app="suppliers">
    <ErrorTrackerProvider>
      <ErrorBoundary>
        <LegacyGqlClientProvider>
          <GqlClientProvider>
            <SessionProvider>
              <ApolloWsClientProvider>
                <MsgsProvider>
                  <StableNavigateProvider>
                    <QueryParamProvider
                      adapter={ReactRouter6Adapter}
                      options={{
                        searchStringToObject: qs.parse,
                        objectToSearchString: qs.stringify,
                      }}
                    >
                      <DealerHubRedirect>
                        <EnvironmentBanner />
                        <HashLinks />
                        <Routes>
                          <Route path="/settings/*" element={<Settings />} />
                          <Route path="/product-diagnostics" element={<ProductDiagnostics />} />
                          <Route path="/products" element={<Products />} />
                          <Route path="/products/create" element={<CreateProduct />} />
                          <Route path="/products/:id" element={<Product />} />
                          <Route path="/orders/create" element={<CreateOrder />} />
                          <Route path="/orders/:storeOrderId/shipping" element={<Shipping />} />
                          <Route path="/orders/:storeOrderId/edit" element={<EditOrder />} />
                          <Route path="/orders/:storeOrderId/*" element={<Order />} />
                          <Route
                            path="/orders/:storeOrderId/configure-shipment"
                            element={<ConfigureShipment />}
                          />
                          <Route path="/orders" element={<Orders />} />
                          <Route path="/rfqs" element={<RequestForQuotes />} />
                          <Route path="/rfqs/create" element={<CreateRequestForQuote />} />
                          <Route path="/rfqs/:requestForQuoteId/*" element={<RequestForQuote />} />
                          <Route path="/customers" element={<Customers />} />
                          <Route path="/customers/:id" element={<Customer />} />
                          <Route path="/accounts" element={<Accounts />} />
                          <Route path="/accounts/:id" element={<Account />} />
                          <Route path="/machines/:machineId" element={<MachineDetails />} />
                          <Route path="/transactions" element={<Transactions />} />
                          <Route path="/metrics" element={<Metrics />} />
                          <Route path="/reports" element={<Reporting />} />
                          <Route path="/inbox" element={<Inbox />} />
                          <Route path="/inbox/messages/:conversationId" element={<Inbox />} />
                          <Route path="/" element={<Navigate to="dashboard" replace />} />
                          <Route path="/dashboard/*" element={<Home />} />
                          <Route path="*" element={<NotFound />} />
                        </Routes>
                      </DealerHubRedirect>
                    </QueryParamProvider>
                  </StableNavigateProvider>
                </MsgsProvider>
              </ApolloWsClientProvider>
            </SessionProvider>
          </GqlClientProvider>
        </LegacyGqlClientProvider>
      </ErrorBoundary>
    </ErrorTrackerProvider>
  </ConfigProvider>
)

export default App
